<template>
  <Modal v-model="modalValue" :title="isEdit ? `编辑` : '新增'" width="800" @on-cancel="modalCancel">
    <Row style="max-height: 600px; overflow-y: auto">
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="120">
          <FormItem label="姓名" prop="name">
            <Input placeholder="请输入姓名" v-model="form.name"></Input>
          </FormItem>
          <FormItem label="性别" prop="gender">
            <RadioGroup v-model="form.gender">
              <Radio v-for="(item, index) in mapData.genderList" :key="index" :label="item.value">
                {{ item.text }}
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="手机" prop="mobile">
            <Input placeholder="请输入手机" v-model="form.mobile"></Input>
          </FormItem>
          <FormItem label="身份证" prop="card">
            <Input placeholder="请输入身份证" v-model="form.card"></Input>
          </FormItem>
          <FormItem label="微信" prop="wechat">
            <Input placeholder="请输入微信" v-model="form.wechat"></Input>
          </FormItem>
          <FormItem label="政治面貌" prop="political_outlook">
            <Select v-model="form.political_outlook" placeholder="请选择政治面貌">
              <Option
                v-for="(item, index) in mapData.politicalOutlook"
                :value="item.value"
                :label="item.text"
                :key="index"
              ></Option>
            </Select>
          </FormItem>
          <FormItem label="所在地" prop="address_code">
            <Cascader @on-change="addressChange" :data="addressList" v-model="form.address_code"></Cascader>
          </FormItem>
          <FormItem label="学历" prop="education">
            <Input placeholder="请输入学历" v-model="form.education"></Input>
          </FormItem>
          <FormItem label="工作单位/机构" prop="unit">
            <Input placeholder="请输入工作单位/机构" v-model="form.unit"></Input>
          </FormItem>
          <FormItem label="职位" prop="position">
            <Input placeholder="请输入职位" v-model="form.position"></Input>
          </FormItem>
          <FormItem label="舞蹈种类" prop="dance_category">
            <Input placeholder="请输入舞蹈种类" v-model="form.dance_category"></Input>
          </FormItem>
          <FormItem label="申请所属委员会" prop="committee_type">
            <Select v-model="form.committee_type" placeholder="请选择申请所属委员会">
              <Option
                v-for="(item, index) in mapData.committeeType"
                :value="item.value"
                :label="item.text"
                :key="index"
              ></Option>
            </Select>
          </FormItem>
          <FormItem label="申请协会职位" prop="society_position">
            <Select v-model="form.society_position" placeholder="请选择申请协会职位">
              <Option
                v-for="(item, index) in mapData.societyPosition"
                :value="item.value"
                :label="item.text"
                :key="index"
              ></Option>
            </Select>
          </FormItem>
          <FormItem label="个人履历" prop="resume">
            <Input type="textarea" placeholder="请输入个人履历" v-model="form.resume"></Input>
          </FormItem>
          <FormItem label="形象照" prop="image_photo">
            <uploadFileOne
              @on-change="imageChange($event, 1)"
              :path="form.image_photo"
              :url="form.image_photo_url"
            ></uploadFileOne>
          </FormItem>
          <FormItem label="身份证正面照片" prop="card_front_photo">
            <uploadFileOne
              @on-change="imageChange($event, 2)"
              :path="form.card_front_photo"
              :url="form.card_front_photo_url"
            ></uploadFileOne>
          </FormItem>
          <FormItem label="身份证反面照片" prop="card_opposite_photo">
            <uploadFileOne
              @on-change="imageChange($event, 3)"
              :path="form.card_opposite_photo"
              :url="form.card_opposite_photo_url"
            ></uploadFileOne>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" :loading="btnLoading" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import * as apiMember from '@/api/member'
  import * as mapData from '../map.js'
  import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
  export default {
    name: 'add-card',
    components: {
      uploadFileOne,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        btnLoading: false,
        mapData, // 映射数据
        form: {
          name: '',
          gender: '',
          card: '',
          mobile: '',
          wechat: '',
          political_outlook: '',
          address: [],
          address_code: [],
          education: '',
          unit: '',
          position: '',
          dance_category: '',
          committee_type: '',
          society_position: '',
          resume: '',
          image_photo: '',
          image_photo_url: '',
          card_front_photo: '',
          card_front_photo_url: '',
          card_opposite_photo: '',
          card_opposite_photo_url: '',
        },
        rules: {
          name: [{ required: true, message: '姓名不能为空', triggier: 'blur' }],
          gender: [{ required: true, type: 'number', message: '性别不能为空', triggier: 'change' }],
          mobile: [{ required: true, message: '手机号不能为空', triggier: 'blur' }],
          card: [{ required: true, message: '身份证不能为空', triggier: 'blur' }],
          wechat: [{ required: true, message: '微信号不能为空', triggier: 'blur' }],
          address_code: [{ required: true, type: 'array', message: '所在地不能为空', triggier: 'change' }],
          unit: [{ required: true, message: '工作单位/机构不能为空', triggier: 'blur' }],
          education: [{ required: true, message: '学历不能为空', triggier: 'blur' }],
          position: [{ required: true, message: '职位不能为空', triggier: 'blur' }],
          committee_type: [{ required: true, message: '申请所属委员会不能为空', type: 'number', triggier: 'change' }],
          society_position: [{ required: true, message: '申请协会职位不能为空', type: 'number', triggier: 'change' }],
          resume: [{ required: true, message: '个人简历不能为空', triggier: 'blur' }],
          image_photo: [{ required: true, message: '形象照不能为空', triggier: 'change' }],
          card_front_photo: [{ required: true, message: '身份证正面照片不能为空', triggier: 'change' }],
          card_opposite_photo: [{ required: true, message: '身份证反面照片不能为空', triggier: 'change' }],
          political_outlook: [{ required: true, type: 'number', message: '政治面貌不能为空', trigger: 'change' }],
        },
        addressList: [],
      }
    },
    methods: {
      // 获取详情
      getDetail() {
        apiMember.apiPositionDetail(this.id).then(res => {
          const { data } = res
          this.form.name = data.name
          this.form.gender = data.gender
          this.form.mobile = data.mobile
          this.form.card = data.card
          this.form.wechat = data.wechat
          this.form.political_outlook = data.political_outlook
          this.form.address = data.address
          this.form.address_code = data.address_code
          this.form.unit = data.unit
          this.form.education = data.education
          this.form.position = data.position
          this.form.dance_category = data.dance_category
          this.form.committee_type = data.committee_type
          this.form.society_position = data.society_position
          this.form.resume = data.resume
          this.form.image_photo = data.image_photo
          this.form.image_photo_url = data.image_photo_url

          this.form.card_front_photo = data.card_front_photo
          this.form.card_front_photo_url = data.card_front_photo_url

          this.form.card_opposite_photo = data.card_opposite_photo
          this.form.card_opposite_photo_url = data.card_opposite_photo_url
        })
      },
      // 地址选择确定
      addressChange(value, selectedData) {
        this.form.address = selectedData.map(item => item.label)
      },
      // 图片上传
      imageChange(e, index) {
        if (index == 1) {
          this.form.image_photo = e.path
          this.form.image_photo_url = e.url
        } else if (index == 2) {
          this.form.card_front_photo = e.path
          this.form.card_front_photo_url = e.url
        } else if (index == 3) {
          this.form.card_opposite_photo = e.path
          this.form.card_opposite_photo_url = e.url
        }
      },
      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.btnLoading = true
            if (this.isEdit) {
              apiMember.apiPositionUpdate(this.id, this.form).then(res => {
                this.$Message.success('编辑成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(() => this.btnLoading = false)
            }
          }
        })
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
      // 获取地址
      getRegion() {
        apiMember.apiRegionList().then(res => {
          this.addressList = res.data[0].children
        })
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
      import_url() {
        return process.env.VUE_APP_API_URL + '/admin/upload/image'
      },
      headers() {
        return {
          authorization: localStorage.getItem('token'),
        }
      },
    },
    watch: {
      value(val) {
        if (val && this.isEdit) {
          this.getRegion()
          this.getDetail()
        }
      },
    },
    
  }
</script>

<style scoped lang="less">
  .upload-btn {
    cursor: pointer;
    padding: 20px 20px;
    border-radius: 5px;
    border: 1px dashed #dcdee2;
    text-align: center;
  }
  .upload-btn:hover {
    transition: all 0.2s;
    box-shadow: 2px 2px 24px rgba(0, 0, 0, 0.1);
  }
  .look-img-wrap {
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .look-img {
    margin: 5px;
    display: flex;
    align-items: center;
    width: 110px;
    height: 110px;
    padding: 10px;
    border: 1px dashed rgba(197, 197, 197, 1);
    text-align: center;
    justify-content: space-evenly;
    position: relative;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
  }

  .look-img:hover .demo-upload-list-cover {
    display: block;
  }
  .demo-upload-list-cover i {
    line-height: 98px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
